import { useCallback } from "react"
import { usePessoaFisicaApi } from "../../../infra/geo-veles"
import { useUIService } from "../../ui"
import { useAppDispatch } from "../../../presentation/hooks/store-hooks"
import { setUfCountState } from "../../../application/states/geo-veles"

export const useUFCountService = () => {
    // Dispatch
    const dispatch = useAppDispatch()
    // Infra
    const { findUFCountApi } = usePessoaFisicaApi()
    // Hook
    const { setAlert } = useUIService()

    const findUFCount = useCallback(async () => {
        try {
            const getUFCount = await findUFCountApi()

            dispatch(setUfCountState({
                ufCount: getUFCount
            }))
        } catch (error: any) {
            setAlert({
                message: error.response.data.error,
                type: 'error'
            })
        }
    }, [dispatch, findUFCountApi, setAlert])

    return {
        findUFCount
    }
}